module.exports = __webpack_public_path__ + "static/fb-c7190aab003aa0fae4dd0d41ea31ac3d.jpg";